import { useMutation } from "@tanstack/react-query";

import client from "./client";
import { BaseResp, DelegateListResp } from "./response";

export interface DelegateRequest {
  name: string;
  agentId: number;
  startDate: string;
  endDate: string;
}

export interface DelegateRangeResp extends BaseResp {
  maxDt: number;
}

export interface DelegateCountResp extends BaseResp {
  acceptCount: number;
  delegateCount: number;
}

export const getDelegateList = (): Promise<DelegateListResp> => client.get('v1/delegate/list');

const registerDelegate = (formData: DelegateRequest): Promise<BaseResp> => client.post('v1/delegate', formData);
export const useRegisterDelegate = () => useMutation(registerDelegate);

const deleteDelegate = (agentId: number): Promise<BaseResp> => client.post(`v1/delegate/${agentId}`);
export const useDeleteDelegate = () => useMutation(deleteDelegate);

export const getMaxDelegateRange = (factoryId: string): Promise<DelegateRangeResp> => client.get('v1/admin/delegate/max', { params: { factoryId } });

export const getDelegateCount = (): Promise<DelegateCountResp> => client.get('v1/delegate/mine');